<template>
  <div class="box-align-center box-pack-between main">
    <div class="whiteBg">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="单选题" name="0">
          <singleChoiceQuestion></singleChoiceQuestion>
        </el-tab-pane>
        <el-tab-pane label="多选题" name="1">
          <multipleChoiceQuestions></multipleChoiceQuestions>
        </el-tab-pane>
        <el-tab-pane label="判断题" name="2">
          <tureOrFalseQuestions></tureOrFalseQuestions>
        </el-tab-pane>
        <el-tab-pane label="填空题" name="3">
          <blanksQuestions></blanksQuestions>
        </el-tab-pane>
        <el-tab-pane label="主观题" name="4">
          <subjectiveQuestions></subjectiveQuestions>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import singleChoiceQuestion from './components/singleChoiceQuestion.vue';
import subjectiveQuestions from './components/subjectiveQuestions.vue';
import blanksQuestions from './components/blanksQuestions.vue';
import multipleChoiceQuestions from './components/multipleChoiceQuestions.vue';
import tureOrFalseQuestions from './components/tureOrFalseQuestions.vue';

var that = null;
export default {
  components: {
    singleChoiceQuestion,
    subjectiveQuestions,
    blanksQuestions,
    multipleChoiceQuestions,
    tureOrFalseQuestions,
  },
  data() {
    return {
      activeName: '0',
      currentIndex: 0,
    };
  },
  mounted() {
    that = this;
  },
  methods: {
    //切换菜单
    handleSelect(index) {
      that.currentIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-submenu .el-menu-item {
  min-width: initial;
}
.main {
  padding: 12px;

  .main-left {
    flex-shrink: 0;
    width: 180px;
  }

  .main-right {
    flex: 1;
  }
}
</style>
